import { memoize } from 'lodash';

import type {
  ReferralEligibilityResponse,
  ReferralEligibilityVariables,
} from '@/ducks/programs/celebrations/eligibility/types';

import { REFERRAL_ELIGIBILITY } from '@/ducks/programs/celebrations/eligibility/referral-eligibility';
import getApolloClient from '@/features/apollo/getApolloClient';
import { log } from '@/helpers/util/logger';

const resolver = (params: ReferralEligibilityVariables) => params.reservationId;

export const getReferralEligibility = memoize((params: ReferralEligibilityVariables) => {
  try {
    return _getReferralEligibility(params);
  } catch (error) {
    getReferralEligibility.cache.delete(resolver(params));

    throw error;
  }
}, resolver);

const _getReferralEligibility = async (
  params: ReferralEligibilityVariables,
): Promise<ReferralEligibilityResponse['referralEligibility']> => {
  const { referralType, reservationId } = params;

  try {
    const client = getApolloClient();

    const { data } = await client.mutate<ReferralEligibilityResponse>({
      mutation: REFERRAL_ELIGIBILITY,
      variables: {
        referralType,
        reservationId,
      },
    });

    return data?.referralEligibility || {};
  } catch (error) {
    log(error);
    console.error('Error checking referral eligibility:', error);
    throw error;
  }
};
